module.exports = {
    recorridoData: () => {
        return[
            {
                "START": {
                    "Image": require("./../assets/panoramasMobile/General_01.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-19.000 0 -6.149",
                            "Rotation":"-95.000 -90.000 0",
                            "Scale":"0.75 0.75",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.691 -1.481 -9.479",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-5.027 -0.791 -0.120",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-9.453 -0.791 8.677",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-21.811 -1.481 -12.027",
                            "Rotation":"-95.000 -90.000 0",
                            "Scale":"0.8 0.8",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                    ],
                    "Labels":[
                        {
                            "Position":"-20.484 3.683 1.678",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA MOTOCARRO",
                            "Image": require('./../UI/labels/apache.png').default
                        }
                    ]
                },
                "GENERAL1": {
                    "Image": require("./../assets/panoramasMobile/General_02.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"16.850 0 -3.465",
                            "Rotation":"-95.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.096 0 -6.731",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-5.775 0 -3.095",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"-5.562 0 2.342",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"10.940 0 -4.468",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"6.730 0 8.161",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                    ]
                },

                "FAMILIA APACHE": {
                    "Image": require("./../assets/panoramasMobile/TVSapacheFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"9.655 0 8.472",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        },
                        {
                            "Position":"13.377 0 -10.266",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.600 0 4.792",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"15.769 0 -6.024",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"13.205 0 -15.451",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"7.402 0 -14.160",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"0.338 0 5.537",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"-1.930 0 4.334",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"-3.476 0 1.554",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"-3.000 0 -0.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"-1.890 0 -2.308",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"0.166 0 -4.086",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        },
                    ]
                },
                "FAMILIA MOTOCARRO": {
                    "Image": require("./../assets/panoramasMobile/TVSmotocarroFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"5.993 0 -13.998",
                            "Rotation":"-88.406 0.000 90",
                            "Scale":"0.7 0.7",
                            "goTo":"START"
                        },
                        {
                            "Position":"1.699 0 5.875",
                            "Rotation":"-90 0.000 90",
                            "Scale":"0.45 0.45",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"13.292 0 -2.928",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-1.690 0 9.273",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"6.594 0 9.273",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"1.892 0 -10.896",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.736 0 -5.133",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"Motocarro King Basico"
                        },
                        {
                            "Position":"-2.433 0 -0.957",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial"
                        },
                        {
                            "Position":"-3.373 0 2.974",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full"
                        },
                    ]
                },
                "FAMILIA NTORQ": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125Familia.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"0.706 0 -6.044",
                            "Rotation":"-95.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"0.706 0 15.690",
                            "Rotation":"-84.357 180.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-3.063 0 9.692",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"12.197 0 0.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"4.503 0 -2.274",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.35 0.35",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-4.197 -0.510 2.267",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi"
                        },
                        {
                            "Position":"-3.698 -0.510 -0.923",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing"
                        },
                        {
                            "Position":"-3.008 -0.510 -4.407",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125"
                        },
                    ],
                    "Labels":[
                        {
                            "Position":"-14.645 4.211 8.144",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA MOTOCARRO",
                            "Image": require('./../UI/labels/ntorq-fi.png').default
                        },
                        {
                            "Position":"-14.394 4.191 0.322",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA MOTOCARRO",
                            "Image": require('./../UI/labels/ntorq-race.png').default
                        },
                        {
                            "Position":"-15.487 4.329 -7.783",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA MOTOCARRO",
                            "Image": require('./../UI/labels/ntorq.png').default
                        }
                    ]
                },
                "FAMILIA SPORT": {
                    "Image": require("./../assets/panoramasMobile/TVSsportFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.511 0 -2.533",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.328 0 -8.111",
                            "Rotation":"-95.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"11.011 0 -2.474",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"8.818 0 11.289",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.509 0 -4.169",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"-2.900 0 -1.229",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"-2.817 0 2.078",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125"
                        },
                        {
                            "Position":"-2.151 0 4.659",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS"
                        },
                    ]
                },
                "FAMILIA NEO": {
                    "Image": require("./../assets/panoramasMobile/TVSneoNXFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.511 0 -2.533",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"5.875 0 3.535",
                            "Rotation":"-95.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILA SPORT"
                        },
                        {
                            "Position":"4.208 0 -8.111",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"17.832 0 -1.263",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.609 0 -1.229",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110"
                        }
                    ]
                },
                "FAMILIA MOTO MES": {
                    "Image": require("./../assets/panoramasMobile/TVSProductoDelMesFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.511 0 -2.533",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"0.474 0 -4.380",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-2.698 0 7.269",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-7.455 0 -6.423",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.419 0 -1.229",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES"
                        }
                    ]
                },

                "Neo NX 110": {
                    "Image": require("./../assets/panoramasMobile/NeoNX110_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.668 0 2.261",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.224 0 -3.522",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"3.130 0 7.974",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110 LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110 LAT DER"
                        }
                    ]
                },
                "Neo NX 110 LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/NeoNX110_LateralIzq.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-4.379 0 6.973",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-9.601 0 5.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.211 0 2.200",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-2.211 0 -1.776",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110 POSTERIOR"
                        }
                    ]
                },
                "Neo NX 110 LAT DER": {
                    "Image": require("./../assets/panoramasMobile/NeoNX110_LateralDer.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"1.658 0 -6.314",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-5.444 0 -12.319",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"6.101 0 -6.155",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.963 0 -2.483",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-1.963 0 2.149",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110 POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -1.083 -2.105",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Freno de disco delantero",
                            "Image": require("./../assets/bullets/NeoNX/Bullet 01.webp").default
                        },
                        {
                            "Position":"-3.826 0.117 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Bodega Bajo el Asiento",
                            "Image": require("./../assets/bullets/NeoNX/Bullet 03.webp").default
                        }
                    ]
                },
                "Neo NX 110 POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/NeoNX110_Posterior.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-9.586 0 -2.706",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-7.423 0 -7.768",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.361 0 -1.297",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110 LAT DER"
                        },
                        {
                            "Position":"-2.361 0 1.070",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110 LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.789 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Cargador de puerto USB, que te permitirá conducir por la cuidad sin preocuparte de tu teléfono se descargue.",
                            "Image": require("./../assets/bullets/NeoNX/Bullet 02.webp").default
                        }
                    ]
                },

                "MOTO MES": {
                    "Image": require("./../assets/panoramasMobile/TVSraider_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"6.207 0 2.734",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"START"
                        },
                        {
                            "Position":"-10.917 0 -5.763",
                            "Rotation":"-95.000 -90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.830 0 -2.910",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-5.073 0 -6.671",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-6.770 0 6.656",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"1.789 0 1.860",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -0.971",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT IZQ"
                        },
                        {
                            "Position":"-2.161 0 3.069",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT DER"
                        }
                    ]
                },
                "MOTO MES LAT IZQ": {
                    "Image":  require("./../assets/panoramasMobile/TVSraider_LateralIzq.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-8.529 0 11.107",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-0.626 0 6.049",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"7.2130 0.647",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.597 0 -12.473",
                            "Rotation":"-85.150 0.000 0.000",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILA SPORT"
                        },
                        {
                            "Position":"13.034 0 -8.693",
                            "Rotation":"-85.150 0.000 90.000",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"-5.383 0 -5.601",
                            "Rotation":"-85.150 0.000 90.000",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.907",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES"
                        },
                    ]
                },
                "MOTO MES LAT DER": {
                    "Image":  require("./../assets/panoramasMobile/TVSraider_LateralDer.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-0.026 0 -6.877",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.55 0.55",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.901 0 -5.121",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.45 0.45",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-5.712 0 14.398",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"3.044 0 2.482",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.246",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES"
                        },
                        {
                            "Position":"-1.662 0 3.033",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES POSTERIOR"
                        }
                    ]
                },
                "MOTO MES POSTERIOR": {
                    "Image":  require("./../assets/panoramasMobile/TVSraider_Posterior.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-7.303 0 -3.493",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-7.132 0 2.234",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-1.820 0 9.340",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.55 0.55",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"6.912 0 14.383",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"11.940 0 9.081",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.55 0.55",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"3.092 0 -4.287",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.55 0.55",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -2.088",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT DER"
                        },
                        {
                            "Position":"-1.692 0 2.088",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT IZQ"
                        }
                    ]
                },

                "Ntorq 125": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"4.668 0 2.261",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-6.032 0 19.271",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"9.891 0 8.680",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-6.352 0 9.744",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-1.065 0 3.024",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"4.571 0 4.556",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 LAT DER"
                        },
                        {
                            "Position":"-2.362 0 2.466",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing"
                        },
                        {
                            "Position":"-3.859 0 4.570",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi"
                        }
                    ]
                },
                "Ntorq 125 LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-3.421 0 6.085",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-10.512 0 12.660",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-6.379 0 6.955",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125"
                        },
                    ]
                },
                "Ntorq 125 LAT DER": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-2.273 0 -6.312",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"9.990 0 3.724",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"6.552 0 -12.430",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"2.386 0 -6.916",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"1.015 0 -1.470",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 POSTERIOR"
                        }
                    ]
                },
                "Ntorq 125 POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-9.271 0 2.088",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-9.013 0 -4.694",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-4.633 0 -3.641",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.370 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Tablero Inteligente: gracias a su tablero inteligente, en donde encontrarás las estadísticas necesarias para que tu experiencia de viaje sea insuperable.",
                            "Image": require("./../assets/bullets/Ntorq125/Bullet 01.webp").default
                        }
                    ]
                },

                "Ntorq 125 Racing": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125Racing_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.166 0 -0.217",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-4.449 0 16.592",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"11.940 0 4.847",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-5.265 0 9.744",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"1.169 0 0.153",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"6.198 0 1.323",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing LAT DER"
                        },
                        {
                            "Position":"-2.362 0 2.355",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi"
                        },
                        {
                            "Position":"1.038 0 -2.248",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.281 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Diseño Racing",
                            "Image": require("./../assets/bullets/Ntorq125RaceEdition/Bullet 02.webp").default
                        }
                    ]
                },
                "Ntorq 125 Racing LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125Racing_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-0.577 0 9.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.014 0 9.759",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing"
                        },
                    ]
                },
                "Ntorq 125 Racing LAT DER": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125Racing_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-4.639 0 -7.905",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"8.617 0 2.359",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-0.433 0 -8.702",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-2.035 0 -4.754",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing POSTERIOR"
                        }
                    ]
                },
                "Ntorq 125 Racing POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125Racing_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-9.271 0 2.088",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.370 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Tablero Inteligente: encontrarás las estadísticas necesarias para que tu experiencia de viaje sea insuperable.",
                            "Image": require("./../assets/bullets/Ntorq125RaceEdition/Bullet 01.webp").default
                        }
                    ]
                },

                "Ntorq 125 fi": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125FI_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.156 0 -2.862",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-3.530 0 16.592",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.450 0 8.863",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"2.425 0 -1.970",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"7.387 0 -0.232",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi LAT DER"
                        },
                        {
                            "Position":"1.069 0 -2.248",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing"
                        },
                        {
                            "Position":"3.186 0 -3.966",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.177 0.714",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Ultima tecnologia en aceleración: impulsada por la tecnología Race Tuned Fuel Injection (RT-FI) que permite disfrutar de una aceleración instantánea con una mayor entrega de potencia, mejora la durabilidad del motor ",
                            "Image": require("./../assets/bullets/Ntorq125FI/Bullet 01.webp").default
                        }
                    ]
                },
                "Ntorq 125 fi LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125FI_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"3.404 0 9.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-2.127 0 10.499",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi"
                        },
                    ]
                },
                "Ntorq 125 fi LAT DER": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125FI_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-4.639 0 -7.905",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-4.639 0 -7.905",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"8.617 0 1.672",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-1.771 0 -8.540",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-3.447 0 -5.034",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"17.101 0 1.672",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.8 0.8",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"17.101 0 -5.670",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.8 0.8",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi POSTERIOR"
                        }
                    ]
                },
                "Ntorq 125 fi POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/Ntorq125FI_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-12.270 0 3.452",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-2.958 0 -12.768",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi LAT IZQ"
                        }
                    ]
                },

                "Sport 100 KLS": {
                    "Image": require("./../assets/panoramasMobile/SportKLS_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"7.027 0 0.094",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.387 0 4.566",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"3.558 0 -5.191",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"12.261 0 -0.621",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"11.436 0 12.977",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS LAT DER"
                        },
                        {
                            "Position":"-0.468 0 3.430",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"0.540 0 6.172",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125"
                        },
                        {
                            "Position":"1.126 0 9.037",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS"
                        }
                    ]
                },
                "Sport 100 KLS LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/SportKLS_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"0.661 0 9.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-1.185 0 15.046",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-4.825 0 5.357",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.45 0.45",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-11.266 0 15.968",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS"
                        },
                    ]
                },
                "Sport 100 KLS LAT DER": {
                    "Image": require("./../assets/panoramasMobile/SportKLS_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-2.311 0 -7.905",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-5.937 0 -6.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-2.033 0 -15.651",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"3.230 0 -6.702",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.809 -0.252",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"DURALIFE: Esta tecnología hace al motor más durable, muy eficiente en su consumo de combustible y garantiza una entrega de potencia más constante.",
                            "Image": require("./../assets/bullets/Sport100KLS/Bullet01.webp").default
                        },
                        {
                            "Position":"-3.826 -1.043 -1.662",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"SBT Sistema de frenado conjunto, activa el freno delantero y trasero simultáneamente para mejorar la eficiencia y seguridad en el frenado.",
                            "Image": require("./../assets/bullets/Sport100KLS/Bullet02.webp").default
                        },
                        {
                            "Position":"-3.826 0.041 0.866",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Sillin Extra largo: Su silla más larga y ancha provee una mayor comodidad para las largas jornadas de trabajo tanto para el piloto como para el pasajero.",
                            "Image": require("./../assets/bullets/Sport100KLS/Bullet03.webp").default
                        }
                    ]
                },
                "Sport 100 KLS POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/SportKLS_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-14.016 0 -0.683",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-9.261 0 -4.683",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS LAT IZQ"
                        }
                    ]
                },

                "Stryker": {
                    "Image": require("./../assets/panoramasMobile/Stryker_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.156 0 -1.215",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.224 0 1.296",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"5.127 0 -6.888",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"13.366 0 -0.350",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"9.797 0 13.676",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker LAT DER"
                        },
                        {
                            "Position":"-1.010 0 -3.375",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"-0.691 0 2.867",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125"
                        },
                        {
                            "Position":"-0.913 0 6.267",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 0.426",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Diseño y Estilo: Su farola de corte agresivo, los flaps deportivos, sus colores impactantes y los hand savers, son la mezcla perfecta para un vehículo que no solo te transportará, si no que te hará resaltar.",
                            "Image": require("./../assets/bullets/Stryker125/Bullet 01.webp").default
                        }
                    ]
                },
                "Stryker LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/Stryker_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-0.753 0 7.878",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-1.134 0 16.017",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"5.822 0 7.491",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-5.075 0 4.150",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-13.428 0 11.203",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker"
                        },
                    ]
                },
                "Stryker LAT DER": {
                    "Image": require("./../assets/panoramasMobile/Stryker_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-2.465 0 -8.025",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-2.185 0 -17.405",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-0.205 0 -3.448",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-9.347 0 -7.430",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"11.672 0 -12.390",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -1.092 -0.295",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":" Tecnología EcoThrust que utiliza un pistón revestido del tipo “MolyCoat” que reduce la fricción dentro del cilindro, lo cual aumenta la potencia y logra una combustión más eficiente.",
                            "Image": require("./../assets/bullets/Stryker125/Bullet 03.webp").default
                        }
                    ]
                },
                "Stryker POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/Stryker_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-10.884 0 3.564",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-6.454 0 -2.985",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-9.725 0 7.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"Neo NX 110"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 -0.114",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Tablero 100% digital, mejora la visibilidad de los indicadores y complementa de manera perfecta el sentido de modernidad que el diseño de la moto entrega.",
                            "Image": require("./../assets/bullets/Stryker125/Bullet 02.webp").default
                        }
                    ]
                },

                "Max 125": {
                    "Image": require("./../assets/panoramasMobile/Max125_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"7.338 0 -1.271",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.820 0 -2.405",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"5.000 0 -9.246",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"13.928 0 1.258",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"9.189 0 12.861",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125 LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125 LAT DER"
                        },
                        {
                            "Position":"-0.311 0 -6.157",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"-0.961 0 -2.773",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"-1.522 0 3.541",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.789 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Farola Delantera: Goza de una potencia extra que te permitirá rodar con mayor seguridad en esos caminos difíciles y poco iluminados de nuestra geografía.",
                            "Image": require("./../assets/bullets/Max125/Bullet 03.webp").default
                        }
                    ]
                },
                "Max 125 LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/Max125_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"1.028 0 12.342",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-0.064 0 5.455",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-13.340 0 11.361",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-0.371 0 15.605",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.803 0 8.262",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125 POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.550 0.244",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Su tanque de combustible tiene una capacidad de 3,96 galones (15 Litros)",
                            "Image": require("./../assets/bullets/Max125/Bullet 04.webp").default
                        }
                    ]
                },
                "Max 125 LAT DER": {
                    "Image": require("./../assets/panoramasMobile/Max125_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-3.188 0 -9.357",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-2.990 -15.248",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-4.239 0 -3.448",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-10.699 0 -7.777",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125 POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.350 1.478",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Sillín a tu altura: Una moto con la altura sillín piso mas baja del segmento, lo que te permite maniobrar con facilidad en terrenos difíciles.",
                            "Image": require("./../assets/bullets/Max125/Bullet 01.webp").default
                        },
                        {
                            "Position":"-3.826 -0.844 -0.438",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Motor: produce una potencia de 10,86 HP @ 8000 RPM, una de las motos tipo doble propósito mas versátiles del mercado,",
                            "Image": require("./../assets/bullets/Max125/Bullet 02.webp").default
                        }
                    ]
                },
                "Max 125 POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/Max125_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-15.280 0 4.598",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-7.395 0 2.199",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125 LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125 LAT IZQ"
                        }
                    ]
                },

                "Sport 100 ELS": {
                    "Image": require("./../assets/panoramasMobile/SportELS_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"7.338 0 -3.816",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.820 0 -4.191",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"5.580 0 -10.407",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"13.928 0 -2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.639 0 8.999",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS LAT DER"
                        },
                        {
                            "Position":"0.639 0 -9.158",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"0.144 0 -5.855",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"-0.301 0 -3.204",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125"
                        }
                    ]
                },
                "Sport 100 ELS LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/SportELS_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"1.028 0 12.342",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.822 0 5.455",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-11.288 0 10.910",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS"
                        },
                    ]
                },
                "Sport 100 ELS LAT DER": {
                    "Image": require("./../assets/panoramasMobile/SportELS_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-3.188 0 -9.357",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-5.092 0 -15.248",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-5.609 0 -5.217",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-11.224 0 -8.089",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -1.053 -2.077",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"SBT Sistema de frenado conjunto, activa el freno delantero y trasero simultáneamente para mejorar la eficiencia y seguridad en el frenado.",
                            "Image": require("./../assets/bullets/Sport100ELS/Bullet03.webp").default
                        },
                        {
                            "Position":"-3.826 -1.053 -0.432",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"DURALIFE: Esta tecnología hace al motor más durable, muy eficiente en su consumo de combustible y garantiza una entrega de potencia más constante.",
                            "Image": require("./../assets/bullets/Sport100ELS/Bullet01.webp").default
                        }
                    ]
                },
                "Sport 100 ELS POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/SportELS_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-15.280 0 4.598",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-7.395 0 2.199",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.779 0.052",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Encendido Electrico: Fácil y cómoda de conducir, pensada en hacerte más fácil todas las labores del día a día",
                            "Image": require("./../assets/bullets/Sport100ELS/Bullet02.webp").default
                        }
                    ]
                },

                "Raider 125": {
                    "Image": require("./../assets/panoramasMobile/TVSraider_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"6.207 0 2.734",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"START"
                        },
                        {
                            "Position":"-10.917 0 -5.763",
                            "Rotation":"-95.000 -90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.830 0 -2.910",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-5.073 0 -6.671",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-6.770 0 6.656",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"1.789 0 1.860",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -0.971",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT IZQ"
                        },
                        {
                            "Position":"-2.161 0 3.069",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT DER"
                        }
                    ]
                },

                "Apache 160 2V": {
                    "Image": require("./../assets/panoramasMobile/RTR1602V_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"5.021 0 7.550",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"11.588 0 3.209",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"MOTO MES"
                        },
                        {
                            "Position":"8.726 0 10.585",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"7.194 0 1.243",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.131",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 0.984",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V LAT DER"
                        },
                        {
                            "Position":"-0.450 0 -2.602",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"0.538 0 -5.566",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"1.845 0 -6.099",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"4.443 0 -5.893",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"7.138 0 -5.546",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ]
                },
                "Apache 160 2V LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/RTR1602V_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-12.928 0 7.413",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[

                        {
                            "Position":"-10.458 0 9.170",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V"
                        },
                    ]
                },
                "Apache 160 2V LAT DER": {
                    "Image": require("./../assets/panoramasMobile/RTR1602V_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"8.032 0 -5.211",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"7.065 0 -8.975",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-1.038 0 -6.696",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"10.252 0 -10.857",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V POSTERIOR"
                        }
                    ]
                },
                "Apache 160 2V POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/RTR1602V_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-5.857 0 -11.026",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-9.895 0 -7.577",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.141",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.091",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V LAT IZQ"
                        }
                    ]
                },

                "Apache 160 4V": {
                    "Image": require("./../assets/panoramasMobile/RTR1604V_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"2.685 0 10.466",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"18.321 0 -5.228",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"9.583 0 12.632",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"4.400 0 2.118",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.398",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.283",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V LAT DER"
                        },
                        {
                            "Position":"-0.450 0 2.548",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"0.384 0 -3.169",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"1.768 0 -4.377",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"3.728 0 -4.443",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"5.326 0 -3.785",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ]
                },
                "Apache 160 4V LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/RTR1604V_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-10.777 0 7.935",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[

                        {
                            "Position":"-6.660 0 9.008",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V"
                        },
                    ]
                },
                "Apache 160 4V LAT DER": {
                    "Image": require("./../assets/panoramasMobile/RTR1604V_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.280 0 -6.934",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"0.645 0 -7.335",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V POSTERIOR"
                        }
                    ]
                },
                "Apache 160 4V POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/RTR1604V_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-8.944 0 -13.564",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-11.256 0 -3.144",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.206",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.179",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V LAT IZQ"
                        }
                    ]
                },

                "Apache 200 fi": {
                    "Image": require("./../assets/panoramasMobile/RTR200FI_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"10.481 0 -1.743",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"11.982 0 -4.903",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"5.990 0 -3.401",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.487",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.487",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi LAT DER"
                        },
                        {
                            "Position":"7.166 0 3.549",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"4.223 0 3.951",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"1.369 0 3.199",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"0.254 0 2.550",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"-0.879 0 -2.617",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 -0.221",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Modos de Manejo: Los 3 modos de manejo sport, urbano y lluvia le dan al piloto el poder de adaptarse a cualquier condición de camino al alcance de un botón.",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/Bullet 04.webp").default
                        },
                        {
                            "Position":"-3.826 1.386 0.777",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Ultima Tecnologia en Aceleración: Está impulsada por la tecnología Race Tuned Fuel Injection (RT-FI) que permite disfrutar de una aceleración instantánea con una mayor entrega de potencia, mejora la durabilidad del motor.  ",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/Bullet 02.webp").default
                        }
                    ]
                },
                "Apache 200 fi LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/RTR 200 FI_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"0.309 0 14.582",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.847 0 8.292",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi"
                        },
                    ]
                },
                "Apache 200 fi LAT DER": {
                    "Image": require("./../assets/panoramasMobile/RTR200FI_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-2.900 0 -16.011",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-6.626 0 -14.876",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-5.180 0 -9.076",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.128 -1.767",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Frenos ABS, Permite un frenado superior con retroalimentación precisa y recuperación del bloqueo de las ruedas. ",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/Bullet 01.webp").default
                        }
                    ]
                },
                "Apache 200 fi POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/RTR200FI_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-14.640 0 -6.563",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.351",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.351",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.354 0.062",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"SmartXconnect Technology,podrás unir tu celular con tu motocicleta y tener a tu disposición el más completo ecosistema de herramientas para disfrutar cada viaje: telemetría de carrera, sensor de inclinación, asistencia de navegación, entre otros",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/BUllet 03.webp").default
                        }
                    ]
                },

                "Apache 180 2V": {
                    "Image": require("./../assets/panoramasMobile/RTR1802V_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.574 0 11.846",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"7.633 0 11.954",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"6.068 0 4.040",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.285",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.285",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V LAT DER"
                        },
                        {
                            "Position":"-0.856 0 5.570",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"-1.569 0 3.265",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"0.088 0 -1.249",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"2.950 0 -2.301",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"5.223 0 -2.245",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 -0.186",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Farola Deportiva:  la Apache RTR 180 2V te permite reaccionar de manera correcta ante cualquier inconveniente que se presente en la vía.",
                            "Image": require("./../assets/bullets/Apache180_2V/Bullet 2.webp").default
                        }
                    ]
                },
                "Apache 180 2V LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/RTR1802V_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-12.958 0 7.484",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-5.022 0 9.404",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.291 1.705",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":"Doble freno de Disco:  la Apache RTR 180 2V te permite reaccionar de manera correcta ante cualquier inconveniente que se presente en la vía.",
                            "Image": require("./../assets/bullets/Apache180_2V/Bullet 1.webp").default
                        }
                    ]
                },
                "Apache 180 2V LAT DER": {
                    "Image": require("./../assets/panoramasMobile/RTR1802V_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"11.738 0 -7.696",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.773 0 -8.546",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"-1.914 0 2.518",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V POSTERIOR"
                        }
                    ]
                },
                "Apache 180 2V POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/RTR1802V_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-9.042 0 -10.988",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.149",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.145",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V LAT IZQ"
                        }
                    ]
                },

                "Apache RR 310": {
                    "Image": require("./../assets/panoramasMobile/RR310_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"13.354 0 -0.316",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"13.223 0 -2.945",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"5.126 0 -0.491",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.463",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310 LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.463",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310 LAT DER"
                        },
                        {
                            "Position":"7.022 0 5.482",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"4.639 0 5.974",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"1.774 0 6.300",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"0.664 0 5.262",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"-0.571 0 2.702",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        }
                    ]
                },
                "Apache RR 310 LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/RR310_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-1.025 0 14.564",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-0.335 0 5.605",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310 POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310"
                        },
                    ]
                },
                "Apache RR 310 LAT DER": {
                    "Image": require("./../assets/panoramasMobile/RR310_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-0.334 0 -14.281",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-2.487 0 -7.593",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310"
                        },
                        {
                            "Position":"-1.914 0 2.518",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310 POSTERIOR"
                        }
                    ]
                },
                "Apache RR 310 POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/RR310_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.162",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310 LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.162",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310 LAT IZQ"
                        }
                    ]
                },

                "Apache 200 2V": {
                    "Image": require("./../assets/panoramasMobile/RTR2004V_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"13.713 0 1.703",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"12.870 0 -0.944",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"5.626 0 -1.971",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.485",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.472",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V LAT DER"
                        },
                        {
                            "Position":"4.460 0 3.971",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"1.829 0 3.267",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"-0.586 0 1.357",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"-0.623 0 -2.800",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"0.655 0 -4.889",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 -0.221",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Farola Led tipo CRAW: Renovación total de look y agresividad en su diseño con esta nueva farola LED, Inspiradas en las motos de alta gama",
                            "Image": require("./../assets/bullets/Apache2004V/Bullet 03.webp").default
                        }
                    ]
                },
                "Apache 200 2V LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/RTR2004V_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-4.3718 0 14.646",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"0.247 0 8.553",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-0.571 0 17.369",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 1.118",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Ingenieria Superiór: Te entrega mayor seguridad y desempeño en su manejo.",
                            "Image": require("./../assets/bullets/Apache2004V/Bullet 04.webp").default
                        }
                    ]
                },
                "Apache 200 2V LAT DER": {
                    "Image": require("./../assets/panoramasMobile/RTR2004V_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-0.626 0 -14.105",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.107 0 -9.256",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-2.654 0 -14.855",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"-1.914 0 2.518",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.305 -1.101",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Slipper Clutch:  ¡Controla la inercia de la moto y aprovecha al máximo sus propiedades deportivas preveniendo bloqueos de llantas y riesgos innecesarios!",
                            "Image": require("./../assets/bullets/Apache2004V/Bullet 01.webp").default
                        }
                    ]
                },
                "Apache 200 2V POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/RTR2004V_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[

                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.008",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.008",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V LAT IZQ"
                        }
                    ]
                },

                "Motocarro King Basico": {
                    "Image": require("./../assets/panoramasMobile/MTbasico_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"9.877 0 -3.018",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-3.999 0 12.505",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.815 0 -1.351",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"12.640 0 7.957",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"6.083 0 -3.770",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-0.883 0 14.710",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-8.003 0 13.001",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-1.599 0 4.535",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.458",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Basico LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.680",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Basico LAT DER"
                        },
                        {
                            "Position":"-3.934 0 3.419",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Especial"
                        },
                        {
                            "Position":"-6.092 0 6.239",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Full"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.708 -0.046",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a la tecnología Duralife patentada por TVS podrás disfrutar de muchas horas de manejo con un gasto mínimo de combustible. ¡Este motocarro es el aliado perfecto a la hora de ahorrar!",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 01.webp").default
                        }
                    ]
                },
                "Motocarro King Basico LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/MTbasico_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"8.101 0 9.585",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"5.361 0 11.463",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-4.584 0 -2.970",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.585 -1.595",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con su versatilidad y adaptabilidad a diversos terrenos, el TVS King está listo para acompañarte en tus jornadas de trabajo sin importar a donde vayas. Con este motocarro no te quedarás atrás.",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 03.webp").default
                        }
                    ]
                },
                "Motocarro King Basico LAT DER": {
                    "Image": require("./../assets/panoramasMobile/MTbasico_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-1.545 0 -14.105",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.524 0 -11.246",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-2.558 0 -10.246",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"12.140 0 3.825",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"2.609 0 0.456",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.783 0 9.147",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NEO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico"
                        },
                        {
                            "Position":"-3.456 0 3.267",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.455 1.388",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con el motocarro TVS King tendrás a tu alcance un vehículo práctico, versátil y muy duradero para acompañar tu progreso. Gracias a sus materiales de larga duración y a los más altos estándares de calidad en su proceso de ensamble podrás disfrutar de tu motocarro por mucho tiempo.",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 02.webp").default
                        }
                    ]
                },
                "Motocarro King Basico POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/MTbasico_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.672",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico LAT DER"
                        },
                        {
                            "Position":"-2.479 0 1.713",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico LAT IZQ"
                        }
                    ]
                },

                "Motocarro King Carpa Especial": {
                    "Image": require("./../assets/panoramasMobile/MTcarpaEspecial_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"12.405 0 -7.097",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-1.536 0 7.389",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.948 0 -4.576",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"0.206 0 1.890",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.250 0 -6.358",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"2.244 0 12.259",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-4.650 0 10.932",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NEO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -2.025",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Especial LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 2.043",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Especial LAT DER"
                        },
                        {
                            "Position":"-3.424 0 3.194",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Full"
                        },
                        {
                            "Position":"2.215 0 -3.551",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Basico"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.708 -0.046",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a la tecnología Duralife patentada por TVS podrás disfrutar de muchas horas de manejo con un gasto mínimo de combustible. ¡Este motocarro es el aliado perfecto a la hora de ahorrar!",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 01.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Especial LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/MTcarpaEspecial_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"0.059 0 14.646",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-3.220 0 5.444",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-9.920 0 11.396",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"2.064 0 15.706",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.972 0 -3.098",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial POSTERIOR"
                        },
                        {
                            "Position":"-1.163 0 1.890",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.585 -1.595",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con su versatilidad y adaptabilidad a diversos terrenos, el TVS King está listo para acompañarte en tus jornadas de trabajo sin importar a donde vayas. Con este motocarro no te quedarás atrás.",
                            "Image": require("./../assets/bullets/MotocarroGSEspecial/Bullet 03.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Especial LAT DER": {
                    "Image": require("./../assets/panoramasMobile/MTcarpaEspecial_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-6.036 0 -14.105",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"6.160 0 -1.424",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-1.854 0 -12.293",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"MOTO MES"
                        },
                        {
                            "Position":"-2.094 0 -12.522",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"12.312 0 1.685",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"12.312 0 -11.940",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"5.714 0 6.252",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"-1.114 0 -5.409",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.449 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial"
                        },
                        {
                            "Position":"-3.636 0 2.922",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.455 1.388",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con el motocarro TVS King tendrás a tu alcance un vehículo práctico, versátil y muy duradero para acompañar tu progreso. Gracias a sus materiales de larga duración y a los más altos estándares de calidad en su proceso de ensamble podrás disfrutar de tu motocarro por mucho tiempo.",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 02.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Especial POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/MTcarpaEspecial_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -2.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial LAT DER"
                        },
                        {
                            "Position":"-2.479 0 2.344",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial LAT IZQ"
                        }
                    ]
                },

                "Motocarro King Carpa Full": {
                    "Image": require("./../assets/panoramasMobile/MTcarpaFull_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"0.626 0 4.575",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"4.087 0 -1.325",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"4.220 0 9.678",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-1.813 0 7.620",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NEO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -2.025",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Full LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 2.043",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Full LAT DER"
                        },
                        {
                            "Position":"4.642 0 -6.810",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MMotocarro King Basico"
                        },
                        {
                            "Position":"2.177 0 -3.716",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Especial"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.708 -0.046",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a la tecnología Duralife patentada por TVS podrás disfrutar de muchas horas de manejo con un gasto mínimo de combustible. ¡Este motocarro es el aliado perfecto a la hora de ahorrar!",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 01.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Full LAT IZQ": {
                    "Image": require("./../assets/panoramasMobile/MTcarpaFull_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-5.790 0 6.787",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"5.330 0 16.196",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.8 0.8",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"0.910 0 5.444",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.856 0 -3.098",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full POSTERIOR"
                        },
                        {
                            "Position":"-2.026 0 1.901",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.585 -1.595",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con su versatilidad y adaptabilidad a diversos terrenos, el TVS King está listo para acompañarte en tus jornadas de trabajo sin importar a donde vayas. Con este motocarro no te quedarás atrás.",
                            "Image": require("./../assets/bullets/MotocarroGSFull/Bullet 03.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Full LAT DER": {
                    "Image": require("./../assets/panoramasMobile/MTcarpaFull_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.400 0 -2.229",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.602 0 -0.224",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-0.599 0 -6.511",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"3.816 0 2.955",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"9.978 0 -14.132",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"1 1",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.910",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full"
                        },
                        {
                            "Position":"-1.914 0 2.518",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.455 1.388",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con el motocarro TVS King tendrás a tu alcance un vehículo práctico, versátil y muy duradero para acompañar tu progreso. Gracias a sus materiales de larga duración y a los más altos estándares de calidad en su proceso de ensamble podrás disfrutar de tu motocarro por mucho tiempo.",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 02.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Full POSTERIOR": {
                    "Image": require("./../assets/panoramasMobile/MTcarpaFull_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -2.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full LAT DER"
                        },
                        {
                            "Position":"-2.479 0 2.344",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full LAT IZQ"
                        }
                    ]
                }
            }
        ] 
    }
}